var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMailCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_check",
    "data-name": "mail check",
    transform: "translate(11971 -19466)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 24,
    height: 24,
    transform: "translate(-11971 19466)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mail_check-2",
    "data-name": "mail check",
    transform: "translate(-11969 19468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4977",
    "data-name": "Group 4977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4961",
    "data-name": "Path 4961",
    d: "M10,0A10,10,0,1,0,20,10,10.013,10.013,0,0,0,10,0Zm0,17.93A7.93,7.93,0,1,1,17.93,10,7.939,7.939,0,0,1,10,17.93Z",
    fill: "#2884ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4962",
    "data-name": "Path 4962",
    d: "M169.965,99.1a14.664,14.664,0,0,0-1.518-.674,3.332,3.332,0,0,1-.83-.46.71.71,0,0,1,.179-1.27,1.439,1.439,0,0,1,.509-.1,3.9,3.9,0,0,1,1.914.374c.3.144.4.1.5-.21.108-.329.2-.662.3-.99a.343.343,0,0,0-.229-.46,4.748,4.748,0,0,0-1.209-.353c-.546-.086-.546-.086-.55-.629,0-.768,0-.768-.78-.764-.113,0-.225,0-.338,0-.363.012-.425.074-.434.431,0,.16,0,.325,0,.485,0,.481,0,.473-.471.637a2.566,2.566,0,0,0-1.9,2.371A2.421,2.421,0,0,0,166.5,99.8a15.667,15.667,0,0,0,1.743.772,2.551,2.551,0,0,1,.634.37.852.852,0,0,1-.208,1.5,2.123,2.123,0,0,1-1.117.144,5.013,5.013,0,0,1-1.7-.5c-.313-.16-.4-.119-.513.218-.092.292-.175.583-.254.875-.108.394-.071.489.313.67a5.647,5.647,0,0,0,1.534.436c.413.066.429.082.434.505,0,.193,0,.386,0,.575a.345.345,0,0,0,.375.386q.432.006.863,0a.33.33,0,0,0,.359-.366c0-.263.012-.526,0-.789a.416.416,0,0,1,.367-.473,2.917,2.917,0,0,0,1.509-.953A2.673,2.673,0,0,0,169.965,99.1Z",
    transform: "translate(-158.243 -89.655)",
    fill: "#2884ff"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMailCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail_check.fbed43af97f3c02c4f5959712e222c5b.svg";